import axios from 'axios';
import pjson from '../../package.json';
import { API_URL } from "./api";
import axiosInstance from "./axiosInstance";

const METHODS = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
};

export function getHeaders(json) {
    const headers = {
        "X-CLIENT-VER": pjson.version,
    };
    if (json) {
        headers['Content-Type'] = 'application/json; charset=UTF-8';
    }
    return headers;
}

function parseJSON(response) {
    if (response.status === 204 || response.status === 205) {
        return null;
    }
    return response.json();
}

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        if (response.data.status === 'fail') {
            const error = new Error(response.data.statusText);
            error.response = response;
            throw error;
        }
        return response.data;
    }
    const error = new Error(response.data.error.message);
    error.response = response;
    throw error;
}

function checkReject(failed) {
    const error = Error(failed.response.data?.error?.message || failed.response.data?.message);
    // console.log('cl checkReject', failed);
    error.response = failed.response;
    throw error;
}

export const request = (url, method, optionsInit = {}) => {
    const options = Object.assign({}, optionsInit);
    options.headers = getHeaders(true);
    options.credentials = 'include';

    return axiosInstance({
        url: API_URL + url,
        method,
        ...options,
    })
        .catch(checkReject)
        .then(checkStatus);
};

export const getRequest = (url, params = {}, options = {}) =>
    request(url, METHODS.GET, { params, ...options });

export const postRequest = (url, body, params = {}, options = {}) =>
    request(url, METHODS.POST, { data: body, params, ...options });

export const putRequest = (url, body, params = {}, options = {}) =>
    request(url, METHODS.PUT, { data: body, params, ...options });

export const deleteRequest = (url, body, params = {}, options = {}) =>
    request(url, METHODS.DELETE, { data: body, params, ...options });
